import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://tribaltech-backend.onrender.com';

export default function AffiliateJoin() {
  const [email, setEmail] = useState('');
  const [name, setName]   = useState('');
  const [state, setState] = useState('idle');
  const [code, setCode]   = useState(null);
  const [err, setErr]     = useState('');

  async function submit(e) {
    e.preventDefault();
    setState('sending'); setErr('');
    try {
      const r = await axios.post(`${API}/api/affiliate/register`, { email, name });
      setCode(r.data.code);
      setState('done');
    } catch (e) {
      setErr(e.response?.data?.error || e.message);
      setState('error');
    }
  }

  return (
    <div style={page}>
      <div style={card}>
        <div style={eyebrow}>Creator Protect · Affiliate Program</div>
        <h1 style={{ color:'#fff', fontSize: 26, margin:'6px 0 10px' }}>Earn from every sale you refer</h1>
        <p style={{ color:'#94a3b8', lineHeight: 1.6, marginBottom: 24 }}>
          Share a creator's storefront link with your audience. When someone buys, you earn up to 9% — paid directly to your bank via Stripe.
        </p>

        {state === 'done' ? (
          <div style={{ padding: 16, background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.3)', borderRadius: 8, color:'#4ade80' }}>
            You're in. Your code is <strong style={{ color:'#fff', fontFamily:'monospace' }}>{code}</strong>.
            Check <strong>{email}</strong> for a sign-in link to your dashboard.
          </div>
        ) : (
          <form onSubmit={submit}>
            <label style={label}>Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" disabled={state === 'sending'} style={input} />
            <label style={label}>Name (optional)</label>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="How should we address you?" disabled={state === 'sending'} style={input} />
            <button type="submit" disabled={state === 'sending'} style={button}>
              {state === 'sending' ? 'Creating account…' : 'Join the program'}
            </button>
            {err && <div style={{ color:'#f87171', fontSize: 13, marginTop: 12 }}>{err}</div>}
          </form>
        )}

        <div style={{ marginTop: 24, fontSize: 12, color:'#666', textAlign:'center' }}>
          Already have an account? <Link to="/affiliate/login" style={{ color:'#a78bfa' }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}

const page  = { minHeight:'100vh', background:'linear-gradient(180deg, #0f0f1e 0%, #0a0a0f 100%)',
                display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px' };
const card  = { background:'#111', borderRadius: 16, padding: 32, maxWidth: 480, width:'100%',
                border:'1px solid #222', boxShadow:'0 20px 60px rgba(0,0,0,0.5)' };
const eyebrow = { fontSize: 11, color:'#888', letterSpacing: 2, textTransform:'uppercase', marginBottom: 6 };
const label = { display:'block', fontSize: 12, color:'#94a3b8', marginBottom: 6, marginTop: 10 };
const input = { width:'100%', padding: 12, borderRadius: 8, background:'#0a0a0a',
                border:'1px solid #222', color:'#fff', fontSize: 14, boxSizing:'border-box' };
const button= { width:'100%', padding: 14, borderRadius: 8, border:'none', background:'#7c3aed',
                color:'#fff', fontSize: 15, fontWeight: 600, cursor:'pointer', marginTop: 18 };
